import { render } from "./Cookies.vue?vue&type=template&id=2cfe92c1&ts=true"
import script from "./Cookies.vue?vue&type=script&lang=ts"
export * from "./Cookies.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__